import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import layouts from './layouts'
import plugins from './plugins'
import filters from './filters'

Vue.config.productionTip = false

const appConf = {
  router,
  store,
  layouts,
  render: h => h(App)
}

Object.assign(appConf, plugins, filters)

new Vue(appConf).$mount('#app')
